export const generateAppConfig = () =>{
    let exportResult = {
        appRepoLocation:"http://localhost:3002",
        backendUrl: "http://localhost:3100",
        appBackendUrl : "http://localhost:4040",
        jsReportUrl: "http://localhost:5488"
    };
    if(process.env.REACT_APP_PRODUCTION_MODE ==='TEST'){
        exportResult.appRepoLocation = "https://sg-app.theonetenggolresort.com";
        exportResult.backendUrl = "https://sg-api.theonetenggolresort.com/admin";
        exportResult.appBackendUrl = "https://sg-api.theonetenggolresort.com/app";
        exportResult.jsReportUrl= "https://sg-report.theonetenggolresort.com";
    }  
    
    if(process.env.REACT_APP_PRODUCTION_MODE ==='PROD'){
        exportResult.appRepoLocation = "https://app.theonetenggolresort.com";
        exportResult.backendUrl = "https://api.theonetenggolresort.com/admin";
        exportResult.appBackendUrl = "https://api.theonetenggolresort.com/app";
        exportResult.jsReportUrl= "https://report.theonetenggolresort.com";
    }  
    return exportResult;
}